module.exports = "/_next/static/images/contact-mobile@2x-8d535a058548e014de8621cbbd0bcaea.png";